document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('[data-countdown-end]');
  if (!elements.length) return;

  function render(el) {
    const end = new Date(el.dataset.countdownEnd).getTime();
    if (Number.isNaN(end)) {
      el.classList.add('is-ended');
      return true;
    }

    const diff = end - Date.now();
    if (diff <= 0) {
      el.classList.add('is-ended');
      return true;
    }

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    const dayEl = el.querySelector('[data-cd-days]');
    const hourEl = el.querySelector('[data-cd-hours]');
    const minuteEl = el.querySelector('[data-cd-minutes]');
    const secondEl = el.querySelector('[data-cd-seconds]');
    if (dayEl) dayEl.textContent = String(days).padStart(2, '0');
    if (hourEl) hourEl.textContent = String(hours).padStart(2, '0');
    if (minuteEl) minuteEl.textContent = String(minutes).padStart(2, '0');
    if (secondEl) secondEl.textContent = String(seconds).padStart(2, '0');
    return false;
  }

  function tick() {
    let allEnded = true;
    elements.forEach((el) => {
      if (!render(el)) allEnded = false;
    });
    if (allEnded) clearInterval(interval);
  }

  tick();
  const interval = setInterval(tick, 1000);
});
